// The label for a message whose author is not a CRM user or customer.
//
// An internal note ported from Zendesk keeps author_type 'system' (attribution is
// display-only) but may carry { display_name, seat } for the Zendesk-only person who
// wrote it. display_name is genuinely null for about 15 ids that appear nowhere in
// the export, so the seat alone must read as a label, never "null" or an empty name.

const SEAT_WORDS = {
  former_agent: 'former agent',
  light_agent: 'light agent',
};

export function authorLabel(message) {
  const author = message?.author;
  if (!author) return 'System';
  const seat = SEAT_WORDS[author.seat] ?? null;
  const name = typeof author.display_name === 'string' ? author.display_name.trim() : '';
  if (name) return seat ? `${name} (${seat})` : name;
  return seat ? `A ${seat}` : 'System';
}
